import type {
    MembershipSpend,
    MembershipSpendUpsertDto,
} from '@fruitful/member-profile/src/spend/types/Spend';

import { requestBuilder } from '../../http/RequestBuilder';

const useUpsertMembershipSpend = requestBuilder.mutation<
    MembershipSpend,
    MembershipSpendUpsertDto
>({
    endpoint: '/api/membership-spend',
    method: 'POST',
});

export default useUpsertMembershipSpend;
